import { createBrowserRouter, RouteObject } from "react-router-dom";
import { adminRoutes } from "src/routing/domains/admin";
import { authRoutes } from "src/routing/domains/auth";
import { bidPackagesRoutes } from "src/routing/domains/bidPackages";
import { changeLogRoutes } from "src/routing/domains/changeLog";
import { developmentsRoutes } from "src/routing/domains/developments";
import { financesRoutes } from "src/routing/domains/finances";
import { librariesRoutes } from "src/routing/domains/libraries";
import { notFoundRoutes } from "src/routing/domains/notFound";
import { pdfRoutes } from "src/routing/domains/pdf";
import { personalDashboardRoutes } from "src/routing/domains/personalDashboard";
import { projectsRoutes } from "src/routing/domains/projects";
import { rootRoutes } from "src/routing/domains/root";
import { tradePartnersRoutes } from "src/routing/domains/tradePartners";
import { tradesRoutes } from "src/routing/domains/trades";
import { warrantyRoutes } from "src/routing/domains/warranty";

/**
 * Composition root for `RouterProvider` (`src/index.tsx`).
 *
 * Role: data router entry. See `src/routing/README.md`.
 *
 * Domain trees under `AppShell` are registered first. Auth (`GuestShell`) and PDF (`PdfLayout`)
 * are siblings outside `AppShell`. Unknown URLs hit `notFoundRoutes`.
 */

const appShellRoutes: RouteObject[] = [
  ...personalDashboardRoutes,
  ...rootRoutes,
  ...librariesRoutes,
  ...projectsRoutes,
  ...developmentsRoutes,
  ...tradePartnersRoutes,
  ...tradesRoutes,
  ...bidPackagesRoutes,
  ...financesRoutes,
  ...changeLogRoutes,
  ...warrantyRoutes,
  ...adminRoutes,
];

export const appRoutes = [...appShellRoutes, ...authRoutes, ...pdfRoutes, ...notFoundRoutes];

export const router = createBrowserRouter(appRoutes);
